export default "__VITE_ASSET__CqfU5uAQ__"